import React from 'react';
import { Coupon, AssessmentField, RegenerateType } from '../../../../../types/generated.types';
import { PendingApproval } from '../../../../../context/CouponsManageContext';
import CouponAssessmentReadOnly from './CouponAssessmentReadOnly';
import CouponAssessmentSelectable from './CouponAssessmentSelectable';
import LoadingCouponAssessment from './LoadingCouponAssessment';

interface CouponAssessmentWrapperProps {
  assessment: Coupon['assessment'] | null;
  displayAssessment: Coupon['assessment'] | null;
  isRegenerating: boolean;
  regeneratingType: RegenerateType | null;
  isSelectingFields: boolean;
  selectedFields: AssessmentField[];
  onToggleField: (field: AssessmentField) => void;
  pendingApproval?: PendingApproval;
}

const CouponAssessmentWrapper: React.FC<CouponAssessmentWrapperProps> = ({
  assessment,
  displayAssessment,
  isRegenerating,
  regeneratingType,
  isSelectingFields,
  selectedFields,
  onToggleField,
  pendingApproval,
}) => {
  // Check if this coupon has a pending approval
  const isPendingApproval = !!pendingApproval;

  // Check if we're regenerating assessment (from sparkle icon or approval regenerate)
  // Only show loading if this specific coupon is regenerating (isRegenerating), not based on global isGenerating
  const isRegeneratingAssessment =
    isRegenerating && (regeneratingType === RegenerateType.Assessment || regeneratingType === RegenerateType.AssessmentFields);

  if (isRegeneratingAssessment) {
    // Determine which fields to show loading for
    const fieldsToLoad = (isPendingApproval && pendingApproval.regenerateType === RegenerateType.AssessmentFields)
      ? pendingApproval.assessmentFields
      : (regeneratingType === RegenerateType.AssessmentFields ? selectedFields : undefined);

    return (
      <LoadingCouponAssessment
        assessmentFields={fieldsToLoad}
        existingAssessment={assessment}
      />
    );
  }

  if (isSelectingFields) {
    return (
      <CouponAssessmentSelectable
        assessment={displayAssessment}
        selectedFields={selectedFields}
        onToggleField={onToggleField}
      />
    );
  }

  return (
    <CouponAssessmentReadOnly assessment={displayAssessment} />
  );
}

export default CouponAssessmentWrapper;

